<template>
  <div>
    <b-input-group>
      <div class="div-dropdown-component">
        <SingleSelectInteger
          :value.sync="compVehicleTypeId"
          :value-property="'value'"
          :options="optionsVehicleType"
          :readonly="false"
        />
      </div>

      <b-input-group-append>
        <b-button @click="showModalCreate">
          <i class="tim-icons icon-simple-add" style="text-align: center" />
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <VehicleTypeModal ref="vehicleTypeModal" @onSave="onSave" />
  </div>
</template>
    
<script>
export default {
  name: "VehicleTypeDropdownModal",
  props: {
    vehicleTypeId: Number,
  },
  components: {
    VehicleTypeModal: () =>
      import("@/components_rms/vehicle/VehicleType/VehicleTypeModal.vue"),
    SingleSelectInteger: () =>
      import("@/components_rms/base/SingleSelectInteger.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "",
      },
      modelstate: [],
      model: null,
      optionsVehicleType: [{ value: null, text: "" }],
    };
  },
  computed: {
    compVehicleTypeId: {
      get: function () {
        return this.vehicleTypeId;
      },
      set: function (value) {
        this.$emit("update:vehicleTypeId", value);
      },
    },
  },
  created() {
    this.loadOptions();
    this.createNew();
  },
  methods: {
    async loadOptions() {
      try {
        const response = await this.$apiVehicle.get(
          "/vehicleType/listDorpdown/"
        );
        response.data.forEach((type) => {
          this.optionsVehicleType.push({
            value: type.id,
            text: type.name,
          });
        });
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log("Load data error");
              } else {
                console.log(error.response.statusText);
              }
            } else {
              console.log(error.message);
            }
          }
        }
      }
    },
    async onSave(id) {
      console.log(id)
      await this.loadOptions();
      this.compVehicleTypeId = parseInt(id);
    },
    showModalCreate() {
      this.$refs.vehicleTypeModal.openModal(0);
    },
    showToastError(append = false) {
      this.$bvToast.toast(this.alert.error, {
        autoHideDelay: 5000,
        toaster: "b-toaster-top-full",
        variant: "danger",
        appendToast: append,
      });
    },
  },
};
</script>